import styled from 'styled-components'
import Masonry from 'react-masonry-css'
import Wrapper from 'common/wrapper'
import { useStudentProjects } from 'querys/student-projects'
import { P } from 'common/typography'
import { SecondaryButton } from 'common/button'
import StudentProjectsFilter from './student-projects-filter'
import StudentProject from './student-project'

const ProjectsCompletedStyled = styled.section`
  .projects-list {
    display: flex;
    margin-block-start: 24px;
    margin-left: -30px;
    width: auto;
  }
  .projects-list-column {
    padding-left: 24px;
    background-clip: padding-box;
  }
  .more-projects {
    margin-block-start: 24px;
    display: flex;
    justify-content: center;
  }
  .no-results {
    margin-block-start: 24px;
    font-weight: bold;
    font-size: 24px;
    line-height: 32px;
    min-height: 58vh;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--neutral30);
  }
`

const breakpointColumns = {
  default: 4,
  1200: 3,
  900: 2,
  600: 1,
}

function ProjectsCompleted() {
  const { data, fetchNextPage, hasNextPage } = useStudentProjects({ page_size: 24 })

  const hasResults = data?.pages[0].results.length > 0

  const results = data?.pages?.map((page) => (
    page.results.map((project) => (
      <StudentProject key={project.uuid} {...project} />
    ))
  ))

  return (
    <ProjectsCompletedStyled aria-label="Proyectos de estudiantes completados">
      <Wrapper maxWidth={1366}>
        <StudentProjectsFilter />
        {hasResults ? (
          <Masonry
            breakpointCols={breakpointColumns}
            className="projects-list"
            columnClassName="projects-list-column"
          >
            {results}
          </Masonry>
        ) : (
          <div className="no-results">
            <P align="center">No encontramos el proyecto que buscabas</P>
          </div>
        )}
        {hasNextPage ? (
          <div className="more-projects">
            <SecondaryButton onClick={() => fetchNextPage()}>
              Mostrar más proyectos
            </SecondaryButton>
          </div>
        ) : null}
      </Wrapper>
    </ProjectsCompletedStyled>
  )
}

export default ProjectsCompleted
